import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

class SalonScroll {
	constructor() {
		let cache = {};

		let initFunc = () => {
			initCache();
			if (!cache.frise) return;
			initScrollTrigger();
		};

		let initCache = () => {
			cache.frise = document.querySelector('.salon-frise');
			cache.friseItems = document.querySelectorAll('.salon-frise__item');
			cache.friseDates = document.querySelectorAll('.salon-frise__date');
			cache.friseTexts = document.querySelectorAll('.salon-frise__description, .salon-frise__description p, .salon-frise__link');
		};

		let initScrollTrigger = () => {
			let tl = gsap.timeline({
				scrollTrigger: {
					trigger: cache.frise,
					start: 'center center',
					end: '80% 60%',
					scrub: true,
				}
			});

			// Background transition
			tl.to(cache.frise, {
				backgroundColor: '#ffffff',
			}, 0);

			// Text colors
			tl.to(cache.friseDates, {
				color: '#272623',
			}, 0);

			tl.to(cache.friseTexts, {
				color: '#272623',
			}, 0);

			// Border colors
			tl.to(cache.friseItems, {
				borderTopColor: 'rgba(39, 38, 35, 0.15)',
			}, 0);
		};

		initFunc();
	}
}

export { SalonScroll };
